import { Sheet } from '@cellula/react';
import { AuthMethods } from './_auth_methods.component';
import { Slot } from '@radix-ui/react-slot';
import { useResolveController } from '@visiba/instantiation';
import { AuthController } from './auth.controller';
import { useFeatureFlag } from '@application/feature_flags/use_feature_flag';

export function AuthSignInSheet({ returnUrl, trigger, onClose, onCloseAnimationEnd, onCloseAutoFocus, onOpen }: Props) {
	const authController = useResolveController(AuthController);
	const useIDP = useFeatureFlag('CareExperience.PW.Idp');

	if (!useIDP) {
		function handleTriggerClick() {
			onOpen?.();
			window.dispatchEvent(
				new CustomEvent('triggerSignIn', {
					detail: { target: authController.getReturnUrl(returnUrl), openTargetWith: 'NativeNavigation', leave: false },
				}),
			);
		}

		return <Slot onClick={handleTriggerClick}>{trigger}</Slot>;
	}

	return (
		<Sheet
			label='' // We don't want any label. We will use a H1 in the AuthMethods component instead.
			onClose={onClose}
			onCloseAnimationEnd={onCloseAnimationEnd}
			onCloseAutoFocus={onCloseAutoFocus}
			onOpen={onOpen}
			trigger={trigger}
		>
			<AuthMethods returnUrl={returnUrl} />
		</Sheet>
	);
}

interface Props {
	returnUrl: string;
	trigger: JSX.Element;
	onClose?: () => void;
	onCloseAnimationEnd?: () => void;
	onCloseAutoFocus?: (event: Event) => void;
	onOpen?: () => void;
}
